export default "__VITE_ASSET__fc4f447e__"